import axios from 'axios';

const api = axios.create({
  baseURL: 'https://app.petattend.com.br/index.php/api/'
});

export default api;
